import React from 'react';

import classnames from 'classnames';

import {Session} from 'nutshell-core/session';

import {FormattedNumberField} from 'shells/formatted-number-field/formatted-number-field';
import {PencilOutlineIcon} from 'shells/icon';
import {Body} from 'shells/typography/body';

import {formatCurrencyDisplay} from './helpers';

type Props = {
    cellLabel: string;
    value: number | null;
    isEditing: boolean;
    isReadOnly: boolean;
    autoFocus?: boolean;
    onChange?: (amount: number) => void;
    onEdit?: () => void;
};

export function UserQuotaTableCell(props: Props) {
    const [isHovering, setIsHovering] = React.useState(false);
    const currencyCode = Session.getInstanceDefaultCurrencyCode();

    const isEditableOnClick = !props.isReadOnly && !props.isEditing;

    const cellStyle = classnames(
        'flex align-center justify-sb gap-32 full-width px-12 border-box',
        {
            'py-6': props.isEditing,
            'py-12': !props.isEditing,
            'pointer-cursor': isEditableOnClick,
        }
    );

    const handleEditClick = () => {
        if (isEditableOnClick) {
            props.onEdit?.();
        }
    };

    return (
        <div
            className={cellStyle}
            onMouseEnter={() => setIsHovering(true)}
            onMouseLeave={() => setIsHovering(false)}
            onClick={handleEditClick}
        >
            <Body color='dark' size='small' isBold={props.isReadOnly} nowrap={true}>
                {props.cellLabel}
            </Body>
            {props.isEditing ? (
                <FormattedNumberField
                    autoFocus={props.autoFocus}
                    value={props.value}
                    currencyCode={currencyCode}
                    onChange={(next) => props.onChange?.(next ?? 0)}
                    formatOptions={{
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0,
                    }}
                    clearable={true}
                    placeholder=''
                />
            ) : (
                <div className='flex gap-4 align-center'>
                    {isHovering && !props.isReadOnly && (
                        <PencilOutlineIcon size={14} wrapWithDiv={false} />
                    )}
                    {
                        <Body color='dark' size='small'>
                            {formatCurrencyDisplay(props.value, currencyCode)}
                        </Body>
                    }
                </div>
            )}
        </div>
    );
}
